const BASE_URL = '/v1/advertisements'

import fetch from '@/api/fetch-types/fetch'
import { FormSchema } from '@/views/dashboard/Generator/_components/generatorFormSchema'

interface IAdvertisementJobResponse {
  jobId: string
  advertisementIds: string[]
}

export interface IAdvertisementsListResponse {
  items: {
    finishedAt: string
    advertisement: {
      id: string
      jobId: string
      iterationNumber: number
      generationStatus: string
      backgroundFileId: string
      previewResultImageFileId: string
      resultImageFileId: string
      startedAt: string
      finishedAt: string
      createdById: string
      createdAt: string
    }
    id: string
    createdAt: string
    userId: string
  }[]
  page: number
  offset: number
  total: number
  pageSize: number
}

interface ISaveResponse {
  ids: string[]
}

interface IGenerateInputsResponse {
  creationDescription: string
  mainColors: string
  adSlogan: string
  priceDescription: string
}

interface IGenerateRandomInputsResponse {
  productName: string
  adSlogan: string
  price: string
  priceLast30Days: string
}

// interface IAdvertisementJobDetailsResponse {
//   id: string
//   job: {
//     id: string
//     shopLogoFileId: string
//     productImageFileId: string
//     mainColors: string
//     creationDescription: string
//     productName: string
//     adSlogan: string
//     price: string
//     priceDescription: string
//     priceLast30Days: string
//     quality: string
//     status: string
//     areProductInscriptionsCrucial: boolean
//     preferredFontHeadHtml: string
//     backgroundCount: number
//     iterationsPerBackground: number
//     createdById: string
//     createdAt: string
//   }
//   generationStatus: string
//   iterationNumber: number
//   backgroundFileId: string
//   htmlContent: string
//   previewResultImageFileId: string
//   resultImageFileId: string
//   startedAt: string
//   finishedAt: string
//   llmProvider: string
//   llmModel: string
//   inputTokens: number
//   outputTokens: number
//   createdById: string
// }

export interface IAdvertisementResponse {
  id: string
  job: {
    id: string
    shopLogoFileId: string
    productImageFileId: string
    templateFileId?: string
    mainColors: string
    creationDescription: string
    productName: string
    adSlogan: string
    price: string
    priceDescription: string
    priceLast30Days: string
    quality: string
    status: string
    areProductInscriptionsCrucial: boolean
    preferredFontHeadHtml: string
    backgroundCount: number
    iterationsPerBackground: number
    createdById: string
    resolution: '1536x1024' | '1024x1536' | '1024x1024'
    createdAt: string
  }
  generationStatus: string
  iterationNumber: number
  backgroundFileId: string
  htmlContent: string
  previewResultImageFileId: string
  resultImageFileId: string
  startedAt: string
  finishedAt: string
  llmProvider: string
  llmModel: string
  inputTokens: number
  outputTokens: number
  createdById: string
}

export const createAdvertisementJobService = async (body: FormSchema) =>
  await fetch<IAdvertisementJobResponse>(BASE_URL + '/jobs', { ...body }, true, 'POST')

export const editAdvertisementJobService = async (id: string, body: { prompt: string }) =>
  await fetch<{ id: string }>(BASE_URL + `/${id}/edit`, { ...body }, true, 'POST')

export const advertisementDetailsService = async () =>
  await fetch<IAdvertisementsListResponse>(
    BASE_URL,
    {
      page: 1,
      pageSize: 99999
    },
    true,
    'GET'
  )

export const savedAdvertisementsService = async (page: number) =>
  await fetch<IAdvertisementsListResponse>(
    BASE_URL + '/saved',
    {
      page: page,
      pageSize: 12
    },
    true,
    'GET'
  )

export const advertisementsService = async () =>
  await fetch<IAdvertisementsListResponse>(
    BASE_URL,
    {
      page: 1,
      pageSize: 99999
    },
    true,
    'GET'
  )

export const singleAdvertisementDetailsService = async (id: string) =>
  await fetch<IAdvertisementResponse>(BASE_URL + '/' + id, {}, true, 'GET')

export const saveAdvertisementService = async (id: string) =>
  await fetch<ISaveResponse>(
    BASE_URL + '/saved',
    {
      advertisements: [
        {
          advertisementId: id,
          name: ''
        }
      ]
    },
    true,
    'POST'
  )

export const generateFormInputService = async (body: {
  description: string
  productImageFileTmp: string
}) =>
  await fetch<IGenerateInputsResponse>(
    BASE_URL + '/jobs/generate-form-inputs',
    { ...body },
    true,
    'POST'
  )

export const generateRandomFormInputService = async () =>
  await fetch<IGenerateRandomInputsResponse>(
    BASE_URL + '/jobs/generate-random-form-inputs',
    {},
    true,
    'POST'
  )
